import { Alert } from "antd";
import { useMemo } from "react";
import { Unbookable } from "../../components/organisms/Unbookable";
import useShop from "../../hooks/useShop";
import useUser from "../../hooks/useUsers";
import { getDecodeToken } from "../../shared/utils/Token";

interface UnbookablePageProps {}

export const UnbookablePage: React.FC<UnbookablePageProps> = () => {
  const { shop } = useShop();
  const { getUserID } = useUser();

  const master = useMemo(() => {
    const info = getDecodeToken();

    return shop === undefined ? false : info?.isMaster && +shop === getUserID();
  }, [shop]);

  return (
    <div>
      {master && (
        <Alert
          message="마스터 계정으로 로그인 하신 상태입니다. 예약 설정을 변경하려면 개별 매장 계정으로 변경 후 진행해주세요."
          type="warning"
          showIcon
        />
      )}
      {((shop && master === false) || !shop) && <Unbookable />}
    </div>
  );
};
